import { ScreenName, ScreenRoute } from "@spike/app2-sitemap/src/auth.js";
import { RouteRecordRaw } from "vue-router";
import AcceptInviteView from "./views/AcceptInvite.vue";
import ForgotPasswordCompleteView from "./views/forgot-password/Complete.vue";
import ForgotPasswordSetPasswordView from "./views/forgot-password/SetPassword.vue";
import ForgotPasswordStartView from "./views/forgot-password/Start.vue";
import ForgotPasswordVerifyView from "./views/forgot-password/Verify.vue";
import LockedView from "./views/Locked.vue";
import NotFound from "./views/NotFound.vue";
import SignInView from "./views/SignIn.vue";
import SignUpView from "./views/SignUp.vue";
import TeamCreateView from "./views/TeamCreate.vue";
import TeamInviteView from "./views/TeamInvite.vue";
import VerifyLocalEmailView from "./views/VerifyLocalEmail.vue";
import TestView from "./views/Test.vue";

// alias
export import Screen = ScreenName;

// NOTE:
// - https://router.vuejs.org/guide/essentials/dynamic-matching.html
// - match first part of route
// - redirectData.ts will extract the rest
export const SignIn: RouteRecordRaw = {
  path: ScreenRoute.SignIn + ":extra(.*)*",
  name: Screen.SignIn,
  component: SignInView,
};

export const SignUp: RouteRecordRaw = {
  path: ScreenRoute.SignUp + ":extra(.*)*",
  name: Screen.SignUp,
  component: SignUpView,
};

export const VerifyLocalEmail: RouteRecordRaw = {
  path: ScreenRoute.VerifyLocalEmail + ":extra(.*)*",
  name: Screen.VerifyLocalEmail,
  component: VerifyLocalEmailView,
};

export const TeamCreate: RouteRecordRaw = {
  path: ScreenRoute.TeamCreate + ":extra(.*)*",
  name: Screen.TeamCreate,
  component: TeamCreateView,
};

export const TeamInvite: RouteRecordRaw = {
  path: ScreenRoute.TeamInvite + ":extra(.*)*",
  name: Screen.TeamInvite,
  component: TeamInviteView,
};

export const AcceptInvite: RouteRecordRaw = {
  path: ScreenRoute.AcceptInvite + ":extra(.*)*",
  name: Screen.AcceptInvite,
  component: AcceptInviteView,
};

export const ForgotPasswordComplete: RouteRecordRaw = {
  path: ScreenRoute.ForgotPasswordComplete + ":extra(.*)*",
  name: Screen.ForgotPasswordComplete,
  component: ForgotPasswordCompleteView,
};

export const ForgotPasswordSetPassword: RouteRecordRaw = {
  path: ScreenRoute.ForgotPasswordSetPassword + ":extra(.*)*",
  name: Screen.ForgotPasswordSetPassword,
  component: ForgotPasswordSetPasswordView,
};

export const ForgotPasswordStart: RouteRecordRaw = {
  path: ScreenRoute.ForgotPasswordStart + ":extra(.*)*",
  name: Screen.ForgotPasswordStart,
  component: ForgotPasswordStartView,
};

export const ForgotPasswordVerify: RouteRecordRaw = {
  path: ScreenRoute.ForgotPasswordVerify + ":extra(.*)*",
  name: Screen.ForgotPasswordVerify,
  component: ForgotPasswordVerifyView,
};

export const Locked: RouteRecordRaw = {
  path: ScreenRoute.Locked + ":extra(.*)*",
  name: Screen.Locked,
  component: LockedView,
};

export const Test: RouteRecordRaw = {
  path: ScreenRoute.Test + ":extra(.*)*",
  name: Screen.Test,
  component: TestView,
};

export const routes: RouteRecordRaw[] = [
  SignIn,
  SignUp,
  VerifyLocalEmail,
  TeamCreate,
  TeamInvite,
  AcceptInvite,
  ForgotPasswordComplete,
  ForgotPasswordStart,
  ForgotPasswordSetPassword,
  ForgotPasswordVerify,
  Locked,
  Test,

  // Not found
  {
    path: "/:path(.*)",
    component: NotFound,
  },
];
